import Base from '../base.js'
import { statusResponse } from '../responseService'
export default class Plan extends Base {
  constructor () {
    super('/plans')
  }

  getSession () {
    return new Promise((resolve, reject) => {
      this.http.get('plan/session').then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'get', 'sessão'))
      })
    })
  }

  getPlanByCode ($code) {
    return new Promise((resolve, reject) => {
      this.http.get(`plan/${$code}`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'get', 'pagamento'))
      })
    })
  }

  payPreApproval (data) {
    return new Promise((resolve, reject) => {
      this.http.post('plan/pre-approvals', { data }).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'get'))
      })
    })
  }
}
